import React, {useContext, useEffect} from "react";
import FormGroup from "../components/FormGroup";
import Goods from "../components/Goods";
import {GlobalContext} from "../context/GlobalProvider";
import Servis from "../components/Servis";
import FormMessage from "../components/FormMessage";
import {sendServis} from "../action/sendServis";
import Issue from "../components/Issue";

window.servisPdfUrl = window.servisPdfUrl || '';

const ServisForm = () => {
    const {
        state,
        dispatch,
    } = useContext(GlobalContext);

    useEffect(() => {
        if (state.sent) {

        }
    }, [state.sent]);

    const handleChangeInput = (e) => {
        dispatch({
            type: 'CHANGE_GDPR',
            payload: e.target.checked
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault()

        if (state.sending) {
            return;
        }

        sendServis(state)(dispatch)
    }

    if (state.sent) {
        return (
            <FormMessage>
                <h3 className="text-white">
                    Ihre Serviceanfrage <br />
                    wurde erfasst
                </h3>
                <p className="text-center">
                    Ihre Nachricht ist jetzt im Posteingang eines Kollegen gelandet, der in Zusammenarbeit mit dem
                    Servicetechniker eine Lösung vorschlagen und Sie in den nächsten Tagen kontaktieren wird.
                </p>
            </FormMessage>
        )
    }

    return (
        <form className="w-full space-y-6 text-white product-form-placeholder"
              method="post"
              onSubmit={handleSubmit}
              encType="multipart/form-data"
              noValidate
        >
            <Servis/>

            <div className="space-y-6">
                <h4 className="text-white headline-6">Ware, die ich servicieren lassen möchte</h4>
                <Goods/>
            </div>

            <div className="flex flex-col lg:flex-row items-start justify-between gap-4">
                <div className="checkbox-container flex-col gap-4">
                    <label
                        htmlFor="gdpr"
                        className="flex items-start gap-3 cursor-pointer"
                    >
                        <span className="custom-checkbox">
                            <input checked={state.gdpr} onChange={handleChangeInput} id="gdpr" type="checkbox"/>
                            <span className="checkmark"></span>
                        </span>
                        <p
                            className={state.errors['gdpr'] !== undefined
                                ? "text-12 leading-snug letter-spacing-2per line-height-130 text-red-500 placeholder-red-500"
                                : "text-12 text-neutrals-400 leading-snug letter-spacing-2per line-height-130"
                            }
                        >
                            Mit dem Absenden der Anfrage stimme ich der <a target="_blank" href={window.privacyUrl} className="underline">
                                Verarbeitung personenbezogener Daten
                            </a> durch Profirol s.r.o. gemäß den Datenschutzbestimmungen zu.
                            <br/><br/>
                            Ich nehme zur Kenntnis, dass bei einer unberechtigten Reklamation die Behebung des Defekts
                            kostenpflichtig ist. <a
                            href={window.servisPdfUrl} target="_blank" className="underline">Weitere Informationen in
                            der Reklamationsordnung.</a>
                        </p>
                    </label>
                </div>

                <button
                    type="submit"
                    className="form-btn self-start w-full lg:w-auto hover:bg-neutrals-500 transition duration-200 hover:text-white disabled:opacity-60"
                    disabled={state.sending}
                >
                    {state.sending ? "Wird gesendet..." : "Absenden"}
                </button>
            </div>
        </form>
    )
}

export default ServisForm;
